import type { CSSProperties } from 'react';
import { ConceptCard } from '../components/ConceptCard.js';
import { concepts } from '../help/concepts.js';
import { groupConcepts } from '../help/group-concepts.js';
import { GROUP_TITLES } from '../help/types.js';

const pageStyle: CSSProperties = {
  maxWidth: 880,
  margin: '0 auto',
  padding: 'var(--loop-space-300) var(--loop-space-200)',
};

const titleStyle: CSSProperties = {
  fontSize: '1.5rem',
  fontWeight: 664,
  color: 'var(--loop-neutral-1100)',
  marginBottom: 'var(--loop-space-200)',
};

const narrativeStyle: CSSProperties = {
  fontSize: '0.9375rem',
  color: 'var(--loop-neutral-900)',
  lineHeight: 1.6,
  marginBottom: 'var(--loop-space-400)',
};

const groupHeadingStyle: CSSProperties = {
  fontSize: '1.125rem',
  fontWeight: 664,
  color: 'var(--loop-neutral-1100)',
  marginTop: 'var(--loop-space-400)',
  marginBottom: 'var(--loop-space-200)',
  paddingBottom: 'var(--loop-space-100)',
  borderBottom: '1px solid var(--loop-neutral-200)',
};

const footerStyle: CSSProperties = {
  marginTop: 'var(--loop-space-400)',
  paddingTop: 'var(--loop-space-200)',
  borderTop: '1px solid var(--loop-neutral-200)',
  fontSize: '0.8125rem',
  color: 'var(--loop-neutral-700)',
};

export function HelpPage() {
  const groups = groupConcepts(concepts);
  const nameBySlug = new Map(concepts.map((c) => [c.slug, c.name]));
  const date = __HELP_CONCEPTS_DATE__ === 'unknown' ? 'unknown' : __HELP_CONCEPTS_DATE__.slice(0, 10);
  return (
    <div style={pageStyle}>
      <h2 style={titleStyle}>Help — How Diff Vader &amp; Death Star fit together</h2>
      <p style={narrativeStyle}>
        A PR opens in a repo where Diff Vader is enabled. The runner spawns a <a href="#council">council</a>{' '}
        of <a href="#reviewer">reviewers</a>, each emitting <a href="#finding">findings</a> on the diff.
        Those findings roll up into a single <a href="#verdict">verdict</a> against the repo&apos;s{' '}
        <a href="#tier">tier</a> and the policy defined in <a href="#central-yml">central.yml</a>.
        Death Star ingests the verdict, settles it against the PR&apos;s eventual outcome, and surfaces
        the result across <a href="#calibration">calibration</a>, the <a href="#weekly-digest">weekly digest</a>,
        the <a href="#velocity-scorecard">velocity scorecard</a>, and the views below.
      </p>
      {groups.map((g) => (
        <section key={g.group}>
          <h3 style={groupHeadingStyle}>{GROUP_TITLES[g.group]}</h3>
          {g.concepts.map((c) => (
            <ConceptCard key={c.slug} concept={c} nameBySlug={nameBySlug} />
          ))}
        </section>
      ))}
      <footer style={footerStyle}>
        Definitions current as of {date} (commit {__HELP_CONCEPTS_COMMIT__}).
      </footer>
    </div>
  );
}
